import { UserClient } from '@frontend/user/api';
import { useState } from 'react';

import { AcceptEulaProps } from './accept-eula.component';

interface ViewProps {
    onSubmit: () => Promise<void>;
    onClickEulaLink: () => void;
    accepted: boolean;
    setAccepted: (accepted: boolean) => void;
}

const useAcceptEula = (props: AcceptEulaProps): ViewProps => {
    const [accepted, setAccepted] = useState<boolean>(false);

    const onClickEulaLink = () => {
        window.open(props.overrideUrl ? props.overrideUrl : 'https://drive.google.com/file/d/1Gpt4N6kvRmvNlRDc6Q3LVMsBRdl5SrYj/view', '_blank');
    };

    const onSubmit = async () => {
        await UserClient.updateTokenUser({ eula_accepted_timestamp: new Date().toISOString() });
        props.callback && props.callback();
    };

    return {
        onSubmit,
        onClickEulaLink,
        accepted,
        setAccepted
    };
};

export default useAcceptEula;
